import React from "react";
import { Modal, Box, Typography, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface DeleteModalProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  title?: string;
  description?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  open,
  onClose,
  onDelete,
  title = "Delete",
  description = "Are you sure you want to delete this item?",
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: "80%", md: 350 },
          bgcolor: "#393939",
          color: "#ffffff",
          boxShadow: 24,
          p: 1,
          borderRadius: "0px",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            variant="h6"
            sx={{ fontSize: "16px", fontWeight: "600", p: 1, pt: 2, px: 3 }}
          >
            {title}
          </Typography>
          <IconButton
            sx={{
              "&:hover": { backgroundColor: "transparent" },
            }}
            onClick={onClose}
          >
            <CloseIcon
              sx={{
                color: "#E12013",
                position: "relative",
                top: -8,
                right: -5,
              }}
            />
          </IconButton>
        </Box>

        <Box sx={{ borderBottom: "1px solid #CCCCCC", marginX: "24px" }}></Box>

        <Box sx={{ p: "28px 24px", textAlign: "left", fontSize: "14px" }}>
          <Typography variant="body1">{description}</Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 3 }}>
          <Button
            variant="contained"
            className="cancelBtn"
            onClick={onClose}
            sx={{
              width: "120px",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="saveBtn"
            onClick={onDelete}
            sx={{
              width: "120px",
            }}
          >
            Delete
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteModal;
